import state from './accessgroup.state'
import mutations from './accessgroup.mutations'
import actions from './accessgroup.actions'

export default {
  state,
  mutations,
  actions
}
